var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeDaot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8343_31358)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9987 0.999674C2.34184 0.999674 0.998698 2.34282 0.998698 3.99967C0.998698 5.65653 2.34184 6.99967 3.9987 6.99967C5.65555 6.99967 6.9987 5.65653 6.9987 3.99967C6.9987 2.34282 5.65555 0.999674 3.9987 0.999674ZM0.332031 3.99967C0.332031 1.97463 1.97365 0.333008 3.9987 0.333008C6.02374 0.333008 7.66536 1.97463 7.66536 3.99967C7.66536 6.02472 6.02374 7.66634 3.9987 7.66634C1.97365 7.66634 0.332031 6.02472 0.332031 3.99967Z",
    fill: "#FB7B33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8343_31358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDaot);
export default __webpack_public_path__ + "static/media/orange-daot.26183a3b7eaf9646236be02362a05c16.svg";
export { ForwardRef as ReactComponent };